module.exports = __webpack_public_path__ + "img/product4.aeca8662.jpg";